import React from 'react'
import styled from 'styled-components';

const Input = props => {
    return (
        <Container {...props} />
    )
}
const Container = styled.input`
    width: 250px;
    padding-left: 5px;
    border: solid 1px #dedede;
    font-size: 14px;
    font-weight: 300;
    color: #999999;
    margin: ${({ margin}) => margin ? margin : ''};
    &:focus {
        border: solid 1px #999999;
        outline: none;
    }
    @media (max-width: 900px){
        width: 100%;
    } 
`

export default Input;


// WEBPACK FOOTER //
// ./src/UserInfo/dev/Input.js